
import React from 'react';
import ProductCard from './ProductCard';

interface Product {
  id: string;
  name: string;
  price: number;
  currency: string;
  image: string;
  description: string;
  discount?: number;
  couponCode?: string;
}

interface ProductsGridProps {
  products: Product[];
}

const ProductsGrid: React.FC<ProductsGridProps> = ({ products }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 w-full animate-fade-in">
      {products.length > 0 ? (
        products.map((product) => (
          <ProductCard
            key={product.id}
            id={product.id}
            name={product.name}
            price={product.price}
            currency={product.currency || 'RWF'}
            image={product.image}
            description={product.description}
            discount={product.discount}
            couponCode={product.couponCode}
          />
        ))
      ) : (
        <div className="col-span-full text-center py-8 text-gray-500">
          No products available in this category.
        </div>
      )}
    </div>
  );
};

export default ProductsGrid;
